export default __webpack_public_path__ + "static/media/guide25.dbae471c.png";